import { reactive, toRefs, defineComponent } from "vue";
export default defineComponent({
  components: {},
  props: {
    processInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    demandTypeComputed(props) {
      switch (props.processInfo.demandType) {
        case 0:
          return '设计需求';
        case 1:
          return '短信需求';
        case 3:
          return '投放监测';
        default:
          return '设计需求';
      }
    }
  },
  setup(props, ctx) {
    let data = reactive({
      approveResult: "1",
      remark: ""
    });
    const onCancel = () => {
      ctx.emit("cancel");
    };
    const onSubmit = () => {
      ctx.emit("submit", {
        id: props.processInfo.id,
        approveResult: data.approveResult,
        remark: data.remark
      });
    };
    return {
      ...toRefs(data),
      onCancel,
      onSubmit
    };
  }
});